import { newDiv, createImage, prepareEvent } from '../RenderUtils';
import { fs } from '../../../helpers/fullscreen';
import { addAnalyticsAttribute } from '../../../helpers/analytics';
import { CONTROLS_EVENTS_GA } from './Constants';

export class FullscreenControl {
  constructor(parentContainer, container, options = {}) {
    this.parentContainer = parentContainer;
    this.container = container;
    this.options = options;
  }

  render() {
    if (!fs.enabled) return;

    const fullscreenImage = createImage('/images/map/fullscreen.svg');
    const fullscreenNode = newDiv(fullscreenImage, this.container);
    fullscreenNode.classList.add('FullscreenControl');

    addAnalyticsAttribute(fullscreenNode, CONTROLS_EVENTS_GA.FULLSCREEN);

    fs.onChange(this.handleChange);
    fullscreenNode.addEventListener('click', this.toggleFullscreen, false);
  }

  handleChange = (e) => {
    prepareEvent(e);
    if (fs.element()) {
      const floorControlOptions = this.parentContainer.querySelector('.FloorControl-options');
      if (floorControlOptions) {
        floorControlOptions.classList.add('-center');
      }
      if (this.parentContainer.webkitRequestFullScreen && this.options.onFullscreen) {
        this.options.onFullscreen();
      }
    } else {
      const floorControlOptions = this.parentContainer.querySelector('.FloorControl-options');
      if (floorControlOptions) {
        floorControlOptions.classList.remove('-center');
      }
      if (this.parentContainer.webkitRequestFullScreen && this.options.offFullscreen) {
        this.options.offFullscreen();
      }
    }
  };

  toggleFullscreen = (e) => {
    prepareEvent(e);
    if (!fs.element()) {
      fs.request(this.parentContainer);
    } else {
      fs.exit();
    }
  };
}
